import React from 'react';
import Grid from "@mui/material/Grid";
import { startOfWeek, endOfWeek } from "../../utils/dateFunctions";
import AccountMaps from './Tables/AccountMap';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from "@mui/material/ToggleButton";
import { userInfo } from '../../../adalConfig';
import FormModal from '../../components/FormModal';
import { Button, Typography } from '@mui/material';
import AddAccountMap from './Forms/AddAccountMap';

const AccountMapPage = (props) => {
    const [startDate, setStartDate] = React.useState(startOfWeek(new Date()));
    const [endDate, setEndDate] = React.useState(endOfWeek(new Date()));
    const [selection, setSelection] = React.useState(0)
    const [open, setOpen] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [user, setUser] = React.useState(userInfo);
    const [userSelect, setUserSelect] = React.useState(0);
    const [userFilter, setUserFilter] = React.useState(null);
    const [location, setLocation] = React.useState(0);
    const [reload, setReload] = React.useState(true);
    const [compTasks, setCompTasks] = React.useState(false);


    React.useEffect(() => {
        updateFilter(userSelect)
    }, [user, userSelect]);

    const handleClose = () => setOpen(false);
    const reloadFunc = () => {
        setReload(!reload);
    }

    const createPO = () => {
        setOpen(true);
        setEdit(false);
        setData(null);
    }
    const updatePO = (array) => (rowd, rowState) => {
        console.log(array, rowState)
        setData(array[rowState.dataIndex]);
        setOpen(true);
        setEdit(false);
    }
    const changeCompTs = (val) => {
        if (val === 0) {
            setCompTasks(false);
        } else {
            setCompTasks(true);
        }
    }
    const updateFilter = (val) => {
        setUserFilter(val === 0 ? user?.userName : null);
    }
    return (
        <React.Fragment>
            <FormModal open={open} handleClose={handleClose} title={"Add/Update Approval Mapping"} >
                <AddAccountMap completed={edit} data={data} access={props.access} reload={reloadFunc} handleClose={handleClose} />
            </FormModal>


            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <Button onClick={createPO} variant="contained" >Add/Update Approval Mapping</Button>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        Best match wins: exact account + sub account, then account, then sub account. Fallback only applies to a CFI0000 map with no account set. Single-field maps apply to any line sharing that value.
                    </Typography>
                </Grid>
          
                <Grid item xs={12}>
                    <AccountMaps userFilter={userFilter} location={location} reload={reload} reloadFunc={reloadFunc} startDate={startDate} endDate={endDate} access={props.access} onClick={updatePO} dashboard compTasks={compTasks} />
                </Grid>
            </Grid>
        </React.Fragment >
    );
};

export default AccountMapPage;
